import axios from 'axios'
import { useState, useEffect } from 'react'
import translations from '../utils/translations'

const DEFAULT_LOCALE = 'en-US'

const SUPPORTED_LOCALES = [
  {
    name: 'English',
    value: 'en-US',
  },
]

const useLoadLocale = ({ version }: { version: string }) => {
  const [isLocaleInitDone, setIsLocaleInitDone] = useState(false)

  const load = async () => {
    let currentLocale = translations.determineLocale()

    const isDetetminedLocaleSupported = SUPPORTED_LOCALES.map(
      (locale) => locale.value
    ).includes(currentLocale)

    if (!isDetetminedLocaleSupported) {
      currentLocale = DEFAULT_LOCALE
    }
    try {
      const { data } = await axios.get(`/locales/${currentLocale}.json`, {
        params: { version },
      })
      translations.init({
        currentLocale,
        locales: {
          [currentLocale]: data,
        },
      })
    } catch (error: unknown) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
    setIsLocaleInitDone(true)
  }

  useEffect(() => {
    load()
  }, [])

  return {
    isLocaleInitDone,
  }
}

export default useLoadLocale
